import { getRequestFormSections } from "@RequestFormV2/constants";
import type { RequestFormMode } from "@RequestFormV2/context/requestFormMode";
import { getSectionKeyForFieldPath } from "@RequestFormV2/utils/getSectionKeyForFieldPath";
import { collectErrorPaths } from "@RequestFormV2/utils/collectErrorPaths";

export function buildErroredSections(errors: unknown, mode: RequestFormMode = "quote"): string[] {
  const sectionsFromPaths = collectErrorPaths(errors).reduce<Set<string>>((acc, path) => {
    const section = getSectionKeyForFieldPath(path, mode);
    if (section) acc.add(section);
    return acc;
  }, new Set());

  return getRequestFormSections(mode)
    .map(({ key }) => key)
    .filter((key) => sectionsFromPaths.has(key));
}
